import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Form from './Form';

const Workspace: React.FC = () => {
  return (
    <Switch>
      <Route path="/workspaces" component={List} isPrivate exact />
      <Route path="/workspaces/add" component={Form} isPrivate />
      <Route path="/workspaces/edit/:id" component={Form} isPrivate />
    </Switch>
  );
};

export default Workspace;
